/**
 * The member's home address as auth-service decides it (ADR-20260930 D7):
 * GET /session home_url, the chat app for a Guest and the admin console for
 * every other role. Null when the session names none (no active membership,
 * or the server could not read it) or cannot be read; the caller then keeps
 * its own fallback. Login UI never derives an app address itself.
 */
export async function readSessionHomeUrl(authServiceUrl: string): Promise<string | null> {
  try {
    const response = await fetch(`${authServiceUrl}/session`, {
      method: 'GET',
      credentials: 'include',
      headers: { Accept: 'application/json' },
    })
    if (!response.ok) return null
    // GET /session answers in snake_case.
    const data = (await response.json()) as Record<string, unknown>
    if (data.authenticated !== true) return null
    const homeUrl = data['home_url']
    return typeof homeUrl === 'string' && homeUrl !== '' ? homeUrl : null
  } catch {
    return null
  }
}
